import script from "./RecordDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordDetailDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__